import { UPLOADS_URL } from "../../config/constants";
import { contactInitials, resolveParticipantImage } from "./supportHelpers";

export default function SupportAvatar({
  ticket,
  teachers = [],
  parents = [],
  name = "",
  image = "",
  className = "",
  size = 40,
}) {
  const resolvedImage = image || resolveParticipantImage(ticket, { teachers, parents });
  const label = name || ticket?.participantName || "";
  const style = { width: size, height: size };

  if (resolvedImage) {
    return (
      <img
        className={`support-avatar${className ? ` ${className}` : ""}`}
        style={style}
        src={`${UPLOADS_URL}/${resolvedImage}`}
        alt={label}
      />
    );
  }

  return (
    <span
      className={`support-avatar is-fallback${className ? ` ${className}` : ""}`}
      style={style}
      aria-hidden={label ? undefined : true}
    >
      {contactInitials(label)}
    </span>
  );
}
